export default "__VITE_ASSET__BOiIPS7E__"